module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9fc5a83c71695290c22d7636e7f4b90a.png";